"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceWorkersInstance = exports.ServiceWorkers = void 0;
const app_1 = require("app");
const TileAnalyticsService_1 = require("../Tile/services/TileAnalyticsService");
class ServiceWorkers extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = 'body';
    }
    OnPageLoad() {
        // Send click url information
        this.sendClickUrl();
        if ('serviceWorker' in navigator === false) {
            return;
        }
        let locationApi = null;
        const config = app_1.ConfigService.GetData() || {};
        if (config && config.locationApi) {
            locationApi = config.locationApi;
        }
        // Get regex from location api url
        const domainRegex = this.getUrlRegex(locationApi);
        const sendLocationUrlToSW = () => {
            domainRegex && this.sendMessageToSW(domainRegex);
            // Message from SW
            /*.then(msg => console.log(msg));*/
        };
        // Register SW
        /*
         * Workbox lifecycle states
         * https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle#handling_updates
         */
        navigator.serviceWorker
            .register('/sw.js') // link to sw file
            .then(function (registration) {
            // Registration was successful
            // Add new rule on page change if SW was activated previously
            sendLocationUrlToSW();
            registration.addEventListener('updatefound', () => {
                // A wild service worker has appeared in reg.installing!
                const newWorker = registration.installing;
                newWorker.addEventListener('statechange', () => {
                    // Register new rule when new SW is activated (updated)
                    if (newWorker.state === 'activated') {
                        sendLocationUrlToSW();
                    }
                });
            });
        }, function (err) {
            // registration failed :(
            // tslint:disable-next-line:no-console
            console.error('ServiceWorker registration failed: ', err);
        });
    }
    // Send regex for location api url
    sendMessageToSW(msg) {
        return new Promise(function (resolve, reject) {
            // Create a Message Channel
            const msgChannel = new MessageChannel();
            // Handler for recieving message reply from service worker
            msgChannel.port1.onmessage = function (event) {
                if (event.data.error) {
                    reject(event.data.error);
                }
                else {
                    resolve(event.data);
                }
            };
            // Send message to service worker along with port for reply
            navigator.serviceWorker.controller.postMessage(msg /*, [msgChannel.port2]*/);
        });
    }
    getUrlRegex(domainString) {
        if (!domainString) {
            return null;
        }
        // eslint-disable-next-line no-useless-escape
        const domainRegex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?([^:\/?\n]+\.[^:\/?\n]+)/i;
        const domain = domainString.match(domainRegex);
        return domain && domain[1] ? new RegExp(`https?://${domain[1]}`, 'i') : null;
    }
    sendClickUrl() {
        const clickUrlPayload = localStorage.getItem('clickUrlPayload');
        if (!clickUrlPayload) {
            return;
        }
        const { url, payload } = JSON.parse(clickUrlPayload);
        const body = JSON.stringify(payload);
        const apiUrl = localStorage.getItem('searchApiUrl') || window.location.origin;
        const clickUrl = new URL(apiUrl).origin;
        TileAnalyticsService_1.TileAnalyticsService.clickUrlRequest(clickUrl, url, body);
    }
}
exports.ServiceWorkers = ServiceWorkers;
exports.ServiceWorkersInstance = new ServiceWorkers();
